export const START_PLAY_VIDEO_EVENT = 'startPlayVideo';
export const STOP_PLAY_VIDEO_EVENT = 'stopPlayVideo';
export const FILTER_SELECTED_EVENT = 'filterSelected';
export const COURSE_CARDS_BADGES_FETCHED_EVENT = 'courseCardsBadgesFetched';